import { useBrokerDesk } from "../../js/hooks/useBrokerDesk";
import { BROKER_DESK } from "../../js/api/brokerDesk";

export default function BrokerScopeBanner() {
  const { active, mode } = useBrokerDesk();
  if (!active) return null;

  return (
    <p className="broker-scope-banner" role="status">
      {mode === BROKER_DESK.mine
        ? "My Business — only work where you are the agent of record. Office files stay on All Agents."
        : "All Agents — office supervision only. Your personal book lives on My Business, so it does not clutter this view."}
    </p>
  );
}
